import { jsx as _jsx } from "react/jsx-runtime";
export default (function () {
  return /*#__PURE__*/_jsx("g", {
    children: /*#__PURE__*/_jsx("path", {
      className: "line",
      d: "M 26,16 A 10,10 0 0 1 16,26 10,10 0 0 1 6,16 10,10 0 0 1 16,6 10,10 0 0 1 26,16 Z"
    })
  });
});